module.exports = __webpack_public_path__ + "img/logo_dense.2d46b838.png";